import { render, staticRenderFns } from "./form-pv5-open-event.vue?vue&type=template&id=0966a897"
import script from "./form-pv5-open-event.vue?vue&type=script&lang=js"
export * from "./form-pv5-open-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports